export const SERVICE_FETCH_PRODUCTS = {
  endpoint: '/getProductsAds',
  method: 'get',
  hostel: true,
};
